import script from "./uploaddocument.vue?vue&type=script&setup=true&lang=js"
export * from "./uploaddocument.vue?vue&type=script&setup=true&lang=js"

import "./uploaddocument.vue?vue&type=style&index=0&id=166f1724&lang=css"

const __exports__ = script;

export default __exports__